export * from './attachment-details-page';
